<template>
  <page-wrapper background="/static/img/anniversary/page-coupon/bg.png" :swiper="swiper" :hasDownBtn="true">
    <div class="main-text ani" swiper-animate-effect="animate__fadeIn">
      <span v-if="data.registrationDateYear > 0"><span class="text-highline">{{data.registrationDateYear}}年</span>以来<br /></span>
      感谢您一路的支持<br />
      送您一张<span class="text-highline">{{data.discountMoney || 99}}元</span>定制病毒无门槛优惠券<br />
      可叠加二十二周年活动折扣使用
    </div>
    <img class="main-image ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-coupon/shape1.png" />
    <div class="main-image-coupon ani" swiper-animate-effect="animate__fadeIn" style="background: url(/static/img/anniversary/page-coupon/coupon.png); background-size: cover;">
      <div class="main-image-coupon-inner">
        <span class="money">{{data.discountMoney || 99}}</span>
      </div>
    </div>
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  props: [
    'swiper', 'data'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .money {
    position: absolute;
    right: 11vw;
    bottom: 6vw;
    // width: 13.06666667vw;
    height: 14.93333333vw;
    font-family: PingFangSC-Semibold;
    font-size: 10.66666667vw;
    font-weight: 600;
    line-height: 56px;
    letter-spacing: -0.3px;
    color: #4681F7;
  }

  .main-text {
    position: absolute;
    left: 50%;
    bottom: 53.06666667vw;
    width: 75vw;
    font-size: 4.26vw;
    line-height: 9.33vw;
    font-weight: 400;
    margin-left: -36.6vw;
    letter-spacing: -0.3px;
    z-index: 99;

    /* 字体 */
    color: #193543;

    .text-highline {
      font-size: 22px;
      font-weight: 600;
    }

    .text-notice {
      font-size: 16px;
      font-weight: 400;
    }
  }

  .main-text-background {
    position: absolute;
    left: 50%;
    bottom: -15.2vw;
    width: 82.1vw;
    margin-left: -41.05vw;
    height: 121.8666667vw;
    z-index: 98;
  }

  .main-image {
    position: absolute;
    right: 7.733333333vw;
    top: 10.93333333vw;
    width: 67.73333333vw;
    height: 76.8vw;
  }

  .main-image-coupon {
    position: absolute;
    left: 50%;
    margin-left: -37.6vw;
    bottom: 15vw;
    width: 75.2vw;
    height: 25.86666667vw;
    z-index: 80;
  }

  .main-image-coupon-inner {
    width: 75.2vw;
    height: 25.86666667vw;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?d44dc41e